import { GridFilterModel, GridSortModel } from '@mui/x-data-grid-pro';
import { viewMode } from 'frappe-gantt';
import { atomWithStorage } from 'jotai/utils';
import { TasksView } from './types';

const tasksViewStorageKey = 'tasksView';
const tasksGanttViewModeKey = 'tasksGanttViewMode';
const tasksTableSortModelKey = 'tasksTableSortModel';
const tasksTableFilterModelKey = 'tasksTableFilterModel';

export const tasksViewState = atomWithStorage<TasksView>(tasksViewStorageKey, 'list');


export const tasksGanttViewModeState = atomWithStorage<viewMode>(tasksGanttViewModeKey, 'Day');

export const tasksTableSortModelState = atomWithStorage<GridSortModel | undefined>(tasksTableSortModelKey, undefined);

export const tasksTableFilterModelState = atomWithStorage<GridFilterModel | undefined>(tasksTableFilterModelKey, undefined);
